export default {
  MY_PROPERTIES ({ properties }) {
    return properties
  },
  PROPERTY ({ property }) {
    return property
  }
}
